<template>
  <nav class="navbar navbar-expand navbar-light topbar mb-4 static-top shadow">
    <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
    <i class="fa fa-bars"></i>
    </button>
    <ul class="navbar-nav ml-auto">
      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link dropdown-toggle" href="javascript:void(0)">
        <span class="mr-2 text-dark">{{first_name}} {{last_name}}</span>
        <img class="img-profile rounded-circle" v-bind:src="photo_path">
        </a>
      </li>
      <div class="topbar-divider d-none d-sm-block"></div>
      <li class="nav-item dropdown no-arrow mx-1">
        <a class="nav-link dropdown-toggle text-dark" href="javascript:void(0)" data-toggle="modal" data-target="#logoutModal">
        <i class="fas fa-sign-out-alt fa-fw"></i>
        </a>
        <!-- Logout Modal -->
        <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 v-if="language == 'fr'" class="modal-title" id="exampleModalLabel">Déconnexion</h5>
                <h5 v-if="language == 'en'" class="modal-title" id="exampleModalLabel">Logout</h5>
                <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p v-if="language == 'fr'" class="text-center text-uppercase mt-3">êtes-vous sûr de vouloir vous déconnecter ?</p>
                <p v-if="language == 'en'" class="text-center text-uppercase mt-3">are you sure you want to logout ?</p>
              </div>
              <div class="modal-footer">
                <button class="btn btn-warning text-uppercase shadow- w-50" v-on:click="logout" v-bind:disabled="logoutProcess">
                <img class="mr-2" src="../assets/spin.gif" alt="Spin" v-show="logoutProcess">
                  <span v-if="language == 'fr'">Se déconnecter</span>
                  <span v-if="language == 'en'">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>

<style>

</style>

<script>
import router from '../router'
export default {
  data () {
    return {
      logoutProcess: false,
      language: '',
      first_name: '',
      last_name: '',
      username: '',
      role: '',
      photo_path: 'https://i.ibb.co/hZ0zFdy/face1.jpg'
    }
  },
  mounted() {
		this.language = localStorage.getItem('std_language')
    var user = JSON.parse(localStorage.getItem('std_user'))
    this.first_name = user.first_name
    this.last_name = user.last_name
    this.username = user.username
    this.role = user.role_id
  },
  beforeCreate () {
    if (!localStorage.getItem('std_user')) {
      router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    logout () {
      this.logoutProcess = true
      localStorage.removeItem('std_user')
      setTimeout(function () {
        $('#logoutModal').modal('hide')
        this.logoutProcess = false
        router.push({
          name: 'Login'
        })
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Topbar.vue